import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const roofFaceFromJSON = (json: Partial<IRoofFaceData>): RoofFaceRecord => {
  const recordData: IRoofFaceRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new RoofFaceRecord(recordData);
};

export interface IRoofFaceData {
  id: number;
  name: string;
  designator: string;
  location: string;
  level: string;
  orientation: number;
  pitch: number;
  area: number;
  ui: number;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  _destroy?: boolean;
}

export interface IRoofFaceRecord {
  id: number;
  name: string;
  designator: string;
  location: string;
  level: string;
  orientation: number;
  pitch: number;
  area: number;
  ui: number;
  created_at: Date;
  updated_at: Date;

  _destroy: Nullable<boolean>;
}

const defaultRoofFaceProps: IRoofFaceRecord = {
  id: 0,
  name: "",
  designator: "",
  location: "",
  level: "",
  orientation: 0,
  pitch: 0,
  area: 0,
  ui: 0,
  created_at: new Date(),
  updated_at: new Date(),

  _destroy: null,
};

export class RoofFaceRecord extends Record(defaultRoofFaceProps) implements IRoofFaceRecord {}
